<template>
    <el-dialog :visible.sync="show" title="添加/修改">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="日期">
                <el-date-picker v-model="model.date" type="date">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="地区">
                <el-select size="mini" v-model="model.area">
                    <el-option key="taicang" label="太仓" value="taicang" />
                    <el-option key="neimenggu" label="内蒙古" value="neimenggu" />
                    <el-option key="guangdong" label="广东" value="guangdong" />
                    <el-option key="ningbo" label="宁波" value="ningbo" />
                    <el-option key="fujian" label="福建" value="fujian" />
                    <el-option key="chuanyu" label="川渝" value="chuanyu" />
                    <el-option key="shanxixian" label="陕西" value="shanxixian" />
                    <el-option key="anhui" label="安徽" value="anhui" />
                    <el-option key="hebei" label="河北" value="hebei" />
                    <el-option key="lunan" label="鲁南" value="lunan" />
                    <el-option key="lubei" label="鲁北" value="lubei" />
                    <el-option key="shanxitaiyuan" label="山西" value="shanxitaiyuan" />
                    <el-option key="hunan" label="湖南" value="hunan" />
                    <el-option key="hubei" label="湖北" value="hubei" />
                    <el-option key="henan" label="河南" value="henan" />
                    <el-option key="changzhou" label="常州周边" value="changzhou" />
                </el-select>
            </el-form-item>
            <el-form-item label="价格">
                <el-input v-model="model.price"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false">取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { selectImage, selectVideo } from "../../util/event.js";
import { HttpClient } from "../../util/http.js";
import { msgSuccess } from "../../util/toast";
export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null,
        };
    },
    created() {},
    methods: {
        addOrEdit(item) {
            this.show = true;
            this.model = this.deepCopy({
                ...item,
            });
            if (!this.model.date) {
                this.model.date = dayjs().toDate();
            }
        },
        async save() {
            this.loadingSave = true;
            await HttpClient.put("/restful", {
                model: "SH",
                cond: this.model._id,
                updates: this.model,
            });
            msgSuccess();
            this.show = false;
            this.loadingSave = false;
            this.$emit("fetch-data");
        },
        //深拷贝
        deepCopy(obj) {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                //如果是数组
                const myArray = [];
                for (let i = 0; i < obj.length; i++) {
                    myArray.push(this.deepCopy(obj[i]));
                }
                return myArray;
            } else if (typeof obj == "object") {
                //如果是对象
                const myObject = {};
                for (let key in obj) {
                    myObject[key] = this.deepCopy(obj[key]);
                }
                return myObject;
            }
            return obj;
        },
    },
};
</script>

<style scoped lang="less">
</style>

        